import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postTasks = async (payload) => {
  const { data } = await SigliveServiceV1({
    method: 'POST',
    url: `/monitoring-host/tasks`,
    data: payload,
  });

  return data?.data;
};

export default postTasks;
